import script from "./ThemeToggle.vue?vue&type=script&setup=true&lang=ts"
export * from "./ThemeToggle.vue?vue&type=script&setup=true&lang=ts"

import "./ThemeToggle.vue?vue&type=style&index=0&id=4861e453&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4861e453"]])

export default __exports__